import React from "react"
import axios from 'axios'
import { MDCLinearProgress } from '@material/linear-progress';
import $ from "jquery";
import { MDCDataTable } from '@material/data-table';
import { MDCTextField } from '@material/textfield';
import { MDCSnackbar } from '@material/snackbar';
 
var snackbar
 
class CtrlBoxInput extends React.Component {
  constructor(props) {
    super(props);
  }

  render(props) {
    return <label class="mdc-text-field mdc-text-field--outlined" id={"field" + this.props.id} style={{ marginLeft: "10px", width: this.props.width }}>
      <input type="text" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id={"input" + this.props.id} />
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <span class="mdc-floating-label" id={"label" + this.props.id}>{this.props.label}</span>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>
    </label>
  }
}

class CtrlBox extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const fields = {
      fields: {
        sid: document.querySelector('#fieldSid'),
        network: document.querySelector('#fieldNetwork'),
        type: document.querySelector('#fieldType'),
        name: document.querySelector('#fieldName'),
        descr: document.querySelector('#fieldDescr'),
        min: document.querySelector('#fieldMin'),
        max: document.querySelector('#fieldMax'),
        price: document.querySelector('#fieldPrice'),
        item: document.querySelector('#fieldItem'),
        link: document.querySelector('#fieldLink'),
        source: document.querySelector('#fieldSource'),
        source_id: document.querySelector('#fieldSourceID'),
        cost: document.querySelector('#fieldCost'),
      },
      inputs: {
        sid: document.querySelector('#inputSid'),
        network: document.querySelector('#inputNetwork'),
        type: document.querySelector('#inputType'),
        name: document.querySelector('#inputName'),
        descr: document.querySelector('#inputDescr'),
        min: document.querySelector('#inputMin'),
        max: document.querySelector('#inputMax'),
        price: document.querySelector('#inputPrice'),
        item: document.querySelector('#inputItem'),
        link: document.querySelector('#inputLink'),
        source: document.querySelector('#inputSource'),
        source_id: document.querySelector('#inputSourceID'),
        cost: document.querySelector('#inputCost'),
      },
      labels: {
        sid: document.querySelector('#labelSid'),
        network: document.querySelector('#labelNetwork'),
        type: document.querySelector('#labelType'),
        name: document.querySelector('#labelName'),
        descr: document.querySelector('#labelDescr'),
        min: document.querySelector('#labelMin'),
        max: document.querySelector('#labelMax'),
        price: document.querySelector('#labelPrice'),
        item: document.querySelector('#labelItem'),
        link: document.querySelector('#labelLink'),
        source: document.querySelector('#labelSource'),
        source_id: document.querySelector('#labelSourceID'),
        cost: document.querySelector('#labelCost'),
      }
    }
    this.props.setFields(fields)

    document.querySelector('#saveBtn').onclick = e => {
      var s = {}
      for (const i in fields.inputs)
        s[i] = fields.inputs[i].value
      var o = encodeURI(JSON.stringify(s))
      axios.get("https://nakrutkatop.com:443/api/admin/services/edit?o=" + o, { withCredentials: true })
        .then(res => {

          if (res.data.ok) snackbar.openText("Сервис успешно изменён")
          else snackbar.openText("Ошибка")
          this.props.loadServices()
        })
    }

    document.querySelector('#addBtn').onclick = e => {
      var s = {}
      for (const i in fields.inputs)
        s[i] = fields.inputs[i].value
      var o = encodeURI(JSON.stringify(s))
      axios.get("https://nakrutkatop.com:443/api/admin/services/add?o=" + o, { withCredentials: true })
        .then(res => {
          if (res.data.ok) snackbar.openText("Сервис успешно добавлен")
          else snackbar.openText("Ошибка")
          this.props.loadServices()
        })
    }

    document.querySelector('#openBtn').onclick = e => {
      var s = this.props.state.items.filter(el => Number(document.querySelector('#inputSid').value) == el.sid)[0]
      for (const i in fields.fields)
        fields.fields[i].classList.add("mdc-text-field--label-floating")
      for (const i in fields.labels)
        fields.labels[i].classList.add("mdc-floating-label--float-above")
      for (const i in fields.inputs)
        fields.inputs[i].value = s[i] == undefined ? "" : s[i]
    }

    document.querySelector('#prevBtn').onclick = e => {
      var s = this.props.state.items.filter(el => Number(document.querySelector('#inputSid').value) - 1 == el.sid)[0]
      for (const i in fields.fields)
        fields.fields[i].classList.add("mdc-text-field--label-floating")
      for (const i in fields.labels)
        fields.labels[i].classList.add("mdc-floating-label--float-above")
      for (const i in fields.inputs)
        fields.inputs[i].value = s[i] == undefined ? "" : s[i]
    }

    document.querySelector('#nextBtn').onclick = e => {
      var s = this.props.state.items.filter(el => Number(document.querySelector('#inputSid').value) + 1 == el.sid)[0]
      for (const i in fields.fields)
        fields.fields[i].classList.add("mdc-text-field--label-floating")
      for (const i in fields.labels)
        fields.labels[i].classList.add("mdc-floating-label--float-above")
      for (const i in fields.inputs)
        fields.inputs[i].value = s[i] == undefined ? "" : s[i]
    }
    document.querySelectorAll('.mdc-text-field').forEach(e => new MDCTextField(e))
    snackbar = new MDCSnackbar(document.querySelector('#adminSnackbar'));
    snackbar.openText = function (text) {
      document.querySelector("#adminSnackbarText").innerHTML = text
      snackbar.open()
    }
  }

  render(props) {
    return <div className="ibox" style={{ width: "1000px", flex: "0 0 1000px", maxWidth: "1000px", margin: "24px 24px 24px 0" }}>
      <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Создание и изменение сервисов
  <div>
          <button class="mdc-icon-button material-icons" id="prevBtn" style={{ maxWidth: "36px", maxHeight: "36px", padding: "6px", marginTop: "4px" }}>keyboard_arrow_left</button>
          <button class="mdc-icon-button material-icons" id="nextBtn" style={{ maxWidth: "36px", maxHeight: "36px", padding: "6px", marginTop: "4px", marginLeft: "8px" }}>keyboard_arrow_right</button>

          <button class="mdc-button mdc-button--raised" id="openBtn" style={{ marginLeft: "8px" }}>
            <div class="mdc-button__ripple"></div>
            <i class="material-icons mdc-button__icon" aria-hidden="true">launch</i>
            <span class="mdc-button__label">Открыть по SID</span>
          </button>
          <button class="mdc-button mdc-button--raised" id="saveBtn" style={{ marginLeft: "8px" }} >
            <div class="mdc-button__ripple"></div>
            <i class="material-icons mdc-button__icon" aria-hidden="true">save</i>
            <span class="mdc-button__label">Сохранить</span>
          </button>
          <button class="mdc-button mdc-button--raised" style={{ marginLeft: "8px" }} id="addBtn">
            <div class="mdc-button__ripple"></div>
            <i class="material-icons mdc-button__icon" aria-hidden="true">add</i>
            <span class="mdc-button__label">Добавить</span>
          </button>
        </div>
      </h3>
      <div className="ibox_content" style={{ padding: "10px", margin: "0" }}>
        <div className="Summary_Root__3tu91">

          <CtrlBoxInput id="Sid" width="86px" label="SID" />
          <CtrlBoxInput id="Network" width="112px" label="Соц. сеть" />
          <CtrlBoxInput id="Type" width="112px" label="Вид" />
          <CtrlBoxInput id="Name" width="336px" label="Название" />
          <CtrlBoxInput id="Price" width="86px" label="Цена" />
          <CtrlBoxInput id="Min" width="86px" label="Мин" />
          <CtrlBoxInput id="Max" width="86px" label="Макс" />
          <CtrlBoxInput id="Descr" width="964px" label="Описание" />
          <CtrlBoxInput id="Cost" width="184px" label="Себестоимость" />
          <CtrlBoxInput id="Item" width="184px" label="Единица" />
          <CtrlBoxInput id="Link" width="184px" label="Ссылка" />
          <CtrlBoxInput id="Source" width="185px" label="Источник" />
          <CtrlBoxInput id="SourceID" width="185px" label="ID в источнике" />

        </div>
      </div>
    </div>
  }
}

class ServicesListBox extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadServices()

    setTimeout(() => {
      const fields = {
        fields: {
          sid: document.querySelector('#fieldSid'),
          network: document.querySelector('#fieldNetwork'),
          type: document.querySelector('#fieldType'),
          name: document.querySelector('#fieldName'),
          descr: document.querySelector('#fieldDescr'),
          min: document.querySelector('#fieldMin'),
          max: document.querySelector('#fieldMax'),
          price: document.querySelector('#fieldPrice'),
          item: document.querySelector('#fieldItem'),
          link: document.querySelector('#fieldLink'),
          source: document.querySelector('#fieldSource'),
          source_id: document.querySelector('#fieldSourceID'),
          cost: document.querySelector('#fieldCost'),
        },
        inputs: {
          sid: document.querySelector('#inputSid'),
          network: document.querySelector('#inputNetwork'),
          type: document.querySelector('#inputType'),
          name: document.querySelector('#inputName'),
          descr: document.querySelector('#inputDescr'),
          min: document.querySelector('#inputMin'),
          max: document.querySelector('#inputMax'),
          price: document.querySelector('#inputPrice'),
          item: document.querySelector('#inputItem'),
          link: document.querySelector('#inputLink'),
          source: document.querySelector('#inputSource'),
          source_id: document.querySelector('#inputSourceID'),
          cost: document.querySelector('#inputCost'),
        },
        labels: {
          sid: document.querySelector('#labelSid'),
          network: document.querySelector('#labelNetwork'),
          type: document.querySelector('#labelType'),
          name: document.querySelector('#labelName'),
          descr: document.querySelector('#labelDescr'),
          min: document.querySelector('#labelMin'),
          max: document.querySelector('#labelMax'),
          price: document.querySelector('#labelPrice'),
          item: document.querySelector('#labelItem'),
          link: document.querySelector('#labelLink'),
          source: document.querySelector('#labelSource'),
          source_id: document.querySelector('#labelSourceID'),
          cost: document.querySelector('#labelCost'),
        }
      }

      document.querySelectorAll('#delBtn').forEach(e => e.onclick = (el) => {
        axios.get("https://nakrutkatop.com:443/api/admin/services/delete?oid=" + e.getAttribute("oid"), { withCredentials: true })
          .then(res => {
            if (res.data.ok) snackbar.openText("Сервис успешно удалён")
            else snackbar.openText("Ошибка")
            this.props.loadServices()
          })
      })

      document.querySelectorAll('#editBtn').forEach(e => e.onclick = () => {
        var s = this.props.state.items.filter(el => e.getAttribute("oid") == el._id)[0]
        for (const i in fields.fields)
          fields.fields[i].classList.add("mdc-text-field--label-floating")
        for (const i in fields.labels)
          fields.labels[i].classList.add("mdc-floating-label--float-above")
        for (const i in fields.inputs)
          fields.inputs[i].value = s[i] == undefined ? "" : s[i]
      })
    }, 1500)

  }

  render(props) {

    const { error, isLoaded, items } = this.props.state;
    if (error) {
      return <div>Ошибка: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Загрузка...</div>;
    } else {
      return (
        <div className="ibox" style={{ width: "1000px", flex: "0 0 1000px", maxWidth: "1000px" }}>
          <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Сервисы</h3>
          <div className="ibox_content" style={{ padding: "0" }}>
            <div className="Summary_Root__3tu91">
              <div className="mdc-data-table" style={{ width: "100%" }}>
                <table className="mdc-data-table__table" aria-label="Dessert calories">
                  <thead>
                    <tr className="mdc-data-table__header-row">
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">SID</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Соц. сеть</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Вид</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Название</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Цена</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Мин</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Макс</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">   </th>
                    </tr>
                  </thead>
                  <tbody className="mdc-data-table__content" id="historyTable">
                    {items.map(item => (<tr className="mdc-data-table__row">
                      <td className="mdc-data-table__cell"> {item.sid}</td>
                      <td className="mdc-data-table__cell"> {item.network}</td>
                      <td className="mdc-data-table__cell"> {item.type}</td>
                      <td className="mdc-data-table__cell"> {item.name}</td>
                      <td className="mdc-data-table__cell"> {item.price}</td>
                      <td className="mdc-data-table__cell"> {item.min}</td>
                      <td className="mdc-data-table__cell"> {item.max}</td>
                      <td className="mdc-data-table__cell"> <button className="mdc-button mdc-button--raised" style={{ width: "36px", minWidth: "36px" }} id="editBtn" oid={item._id}>
                        <div className="mdc-button__ripple" style={{ width: "36px", minWidth: "36px" }}></div>
                        <i className="material-icons mdc-button__icon" aria-hidden="true" style={{ marginRight: "0px", marginLeft: "0px" }}>create</i>
                      </button>
                        <button className="mdc-button mdc-button--raised" style={{ width: "36px", minWidth: "36px", marginLeft: "8px" }} id="delBtn" oid={item._id}>
                          <div className="mdc-button__ripple" style={{ width: "36px", minWidth: "36px" }}></div>
                          <i className="material-icons mdc-button__icon" aria-hidden="true" style={{ marginRight: "0px", marginLeft: "0px" }}>delete</i>
                        </button>
                      </td>
                    </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      );
    }


  }
}

class ServicesTab extends React.Component {
  constructor(props) {
    super(props);
    this.loadServices = this.loadServices.bind(this)
    this.setFields = this.setFields.bind(this)

    this.state = {
      error: null,
      isLoaded: false,
      items: []
    }

    this.fields = []
  }

  setFields(fields) {
    this.fields = fields
    console.log(fields)
  }

  componentDidMount() {

  }

  loadServices() {
    axios.get("https://nakrutkatop.com:443/api/admin/services", { withCredentials: true })
      .then(res => {
        document.getElementById("mainContent").style.opacity = 1
        this.setState({
          isLoaded: true,
          items: res.data.services
        }, () => { new MDCDataTable(document.querySelector('.mdc-data-table')); })
      })
  }

  render(props) {
    return <div id="mainContent" style={{ opacity: "0", transition: "1.5s opacity" }}>
      <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>
        <CtrlBox loadServices={this.loadServices} state={this.state} setFields={this.setFields} />
      </div>

      <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>
        <ServicesListBox loadServices={this.loadServices} state={this.state} fields={this.fields} />
      </div>
    </div>
  }
}

export default ServicesTab